import { Controller } from '@hotwired/stimulus'
import { driver } from "driver.js"
import { screenSize } from "utils/screen_size"
import AJAX from 'utils/ajax'

export default class extends Controller {
  static values = {
    config: Object
  }

  initialize() {
    this.config = this.configValue

    this._filterMobile()
    this._filterDesktop()

    this._processPreClickElements()
    this._processForceScrollIntoView()
    this._processCloseCallback()

    this.driverObj = driver(this.config)

    // Give a bit of time for event handlers to be set up
    setTimeout(this._autolaunch.bind(this), 1000)
  }

  _filterMobile() {
    const size = screenSize()

    this.config.steps = this.config.steps.filter((stepConfig) => {
      if (!stepConfig.hasOwnProperty("quimbeeOptions") || !stepConfig.quimbeeOptions.hasOwnProperty("mobileOnly")) return true

      return (!!stepConfig.quimbeeOptions.mobileOnly && size !== "xs") ? false : true
    })
  }

  _filterDesktop() {
    const size = screenSize()

    this.config.steps = this.config.steps.filter((stepConfig) => {
      if (!stepConfig.hasOwnProperty("quimbeeOptions") || !stepConfig.quimbeeOptions.hasOwnProperty("desktopOnly")) return true

      return (!!stepConfig.quimbeeOptions.desktopOnly && size === "xs") ? false : true
    })
  }

  _processPreClickElements() {
    this.config.steps.forEach(step => {
      if (step.hasOwnProperty("quimbeeOptions") && step.quimbeeOptions.hasOwnProperty("preClickElement")) {
        step.popover.onPopoverRender = () => {
          document.querySelector(step.quimbeeOptions.preClickElement).click()

          if (step.quimbeeOptions.hasOwnProperty("skipPreClickAnimation") && step.quimbeeOptions.skipPreClickAnimation === true) {
            return
          }
          document.querySelector(step.element).scrollIntoView({ behavior: "smooth", block: "center" })
        }
      }
    })
  }

  _processForceScrollIntoView() {
    this.config.steps.forEach(step => {
      if (step.hasOwnProperty("quimbeeOptions") && step.quimbeeOptions.hasOwnProperty("forceScrollIntoView")) {
        step.popover.onPopoverRender = () => {
          document.querySelector(step.element).scrollIntoView({ behavior: "smooth", block: "center" })
        }
      }
    })
  }

  _processCloseCallback() {
    if (this.config.hasOwnProperty("quimbeeOptions") && this.config.quimbeeOptions.hasOwnProperty("barReview") && this.config.quimbeeOptions.barReview.hasOwnProperty("schedulePreference") && this.config.quimbeeOptions.barReview.hasOwnProperty("guidedCourseId")) {
      const url = `/bar-review/${this.config.quimbeeOptions.barReview.guidedCourseId}/schedule_preferences.json`
      const data = {
        bar_review_schedule_preference: this.config.quimbeeOptions.barReview.schedulePreference
      }

      this.config.onDestroyed = () => {
        AJAX.put(url, data)
      }
    }
  }

  _autolaunch() {
    if (this.config.hasOwnProperty("quimbeeOptions") && this.config.quimbeeOptions.hasOwnProperty("autolaunch") && this.config.quimbeeOptions.autolaunch === true) {
      this.drive()
    }
  }

  drive() {
    this.driverObj.drive()
  }
}
